import { InjectionToken, Provider } from '@angular/core';

/**
 * Configuración de PostHog que la app inyecta desde su `environment`.
 * La lib no importa el environment de la app (respeta las capas del monorepo,
 * igual que `provideApiBaseUrl`): la app pasa los valores por este provider.
 */
export interface IPosthogConfig {
  /** Project API key (`phc_...`). */
  key: string;
  /** Host de la instancia (ej. `https://us.i.posthog.com`). */
  host: string;
}

export const POSTHOG_CONFIG = new InjectionToken<IPosthogConfig>('POSTHOG_CONFIG');

/**
 * Registra la config de PostHog. Usar en el `app.config.ts` de la app:
 * `providePostHog({ key: environment.posthogKey, host: environment.posthogHost })`.
 */
export const providePostHog = (config: IPosthogConfig): Provider => ({
  provide: POSTHOG_CONFIG,
  useValue: config,
});

/**
 * Placeholder de la key en los `environment`. Si la key sigue siendo este valor,
 * el init se saltea para no mandar eventos desde builds sin configurar.
 */
export const POSTHOG_KEY_PLACEHOLDER = 'phc_REEMPLAZAR';
